import * as React from 'react';
import { forwardRef, memo } from 'react';

const CalendarKycIcon = (props, ref) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
    d="M5.75428 6.10352e-05C6.49066 6.10352e-05 7.08761 0.597015 7.08761 1.33339V2.66673H17.7543V1.33339C17.7543 0.597015 18.3512 6.10352e-05 19.0876 6.10352e-05C19.824 6.10352e-05 20.4209 0.597015 20.4209 1.33339V2.66673H21.7543C23.227 2.66673 24.4209 3.86064 24.4209 5.3334V21.3334C24.4209 22.8062 23.227 24.0001 21.7543 24.0001H3.08761C1.61485 24.0001 0.420944 22.8062 0.420944 21.3334V5.3334C0.420944 3.86064 1.61485 2.66673 3.08761 2.66673H4.42094V1.33339C4.42094 0.597015 5.0179 6.10352e-05 5.75428 6.10352e-05ZM21.7543 10.6667H3.08761V21.3334H21.7543V10.6667Z"
      fill="currentColor"
    />
  </svg>
  
);

const ForwardRef = forwardRef(CalendarKycIcon);
const Memo = memo(ForwardRef);
export default Memo;